import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  feedbackWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    alignItems: "flex-start"
  },
  feedbackTitle: {
    flex: 1,
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[200]
  },
  buttonGreen: {
    width: "100%",
    padding: 10,
    display: "block",
    color: "#ffffff",
    textDecoration: "none",
    textAlign: "center",
    fontWeight: 700,
    fontSize: 18,
    border: 0,
    borderRadius: 30,
    cursor: "pointer",
    background: colour.brand.green
  },
  input: {
    appearance: "none",
    width: "100%",
    height: 200,
    padding: 20,
    marginBottom: 20,
    border: `1px solid ${colour.grey[500]}`,
    fontSize: 18,
    color: colour.grey[200],
    borderRadius: 25,
    "::-ms-expand": {
      display: "none"
    },
    ":hover": {
      outline: 0
    },
    ":focus": {
      outline: 0
    }
  }
});
